module.exports = __webpack_public_path__ + "static/img/index-head.d99ad9af.png";